import React, { ReactElement, useEffect } from 'react';
import InlinePortAndWaterwayObjectList from '../../../../map/features/list/components/inline-port-and-waterway-object-list';
import { useDispatch } from 'react-redux';
import { fetchConfiguration, fetchMapCategories, fetchObjects } from '../../../../map/features/map/actions';
import { fetchOrganizersAction } from '../../../../service/organizers';
import { selectKretsAction } from '../../../../catalog/krets-actions';
import ErrorMessageBoundary from '../../../../errors/error-message-boundary';

export interface PortAndWaterwayListContainerProps {
  organizationId?: number;
  title?: string;
}

export default function PortAndWaterwayListContainer(props: PortAndWaterwayListContainerProps): ReactElement {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchConfiguration(dispatch)();
    fetchMapCategories(dispatch)();
    fetchObjects(dispatch)();
    fetchOrganizersAction(dispatch);
    if (props.organizationId) {
      dispatch(
        selectKretsAction([
          {
            value: props.organizationId,
            label: '',
          },
        ])
      );
    }
  }, [dispatch, props.organizationId]);
  return (
    <ErrorMessageBoundary name="inline-port-and-waterway-object-list" errorIsClearable>
      <InlinePortAndWaterwayObjectList title={props.title} />
    </ErrorMessageBoundary>
  );
}
